const MSG = {
  //NETWORK
  ERR_NETWORK  : "네트워크 오류!! \n서버와의 통신에 문제가 발생하였습니다!!",
  ERR_NETWORK_E : "Network error!! \nThere was a problem communicating with the server!!",
  ERR_RESULT  : "데이터처리 중 오류가 발생하였습니다. \n오류코드 : ",
  ERR_RESULT_E : "An error occurred while processing data. \nError code : ",
  ERR_SIGNIN  : "애프터케어 사용자 정보를 확인할 수 없습니다. \n정보 분실시 [ 아이디 | 비밀번호 찾기 ] 통해 정보를 확인하십시오!",
  ERR_SIGNIN_E : "Aftercare user information cannot be confirmed. \nIf you lost your information, \nplease check it using [ID | Password Retrieval]!",
  ERR_UNSIGN  : "사용자를 확인 할 수 없습니다.",
  ERR_UNSIGN_E : "Unable to verify user.",
  ERR_DUPUSR  : "이미 애프터케어 사용자 등록이 완료된 유저 입니다.",
  ERR_DUPUSR_E : "The user has already been registered \nas an aftercare user.",
  ERR_PSSUSR  : "아이디 또는 비밀번호가 올바르지 않습니다",
  ERR_PSSUSR_E : "The ID or password is incorrect.",
  ERR_AUTH    : "권한인증 정보를 확인할 수 없습니다. \n문제가 지속되면 관리자에 문의해주세요!",
  ERR_AUTH_E : "Unable to verify authorization information. \nIf the problem persists, please contact the administrator.",
  ERR_TOKEN   : "접근토큰 정보를 확인할 수 없습니다. \n문제가 지속되면 관리자에 문의해주세요!",
  ERR_TOKEN_E : "Unable to verify access token information. \nIf the problem persists, please contact the administrator.",
  ERR_SESSION : "사이트 세션 토큰인증이 만료되었거나, \n권한이 불충분합니다!!",
  ERR_SESSION_E : "The site session token authentication has expired or \nthe permission is insufficient!!",
  ERR_INPUTVALID : "필수값 등의 입력오류가 발생하였습니다.",
  ERR_INPUTVALID_E : "An error occurred while processing required input values.",
  ERR_LOGIN_E : "Login failed. Please check your credentials. \n** This service is not available to international patients.",

  //PROCESS
  PRCS_SAVECONFIRM : "저장 하시겠습니까?",
  PRCS_SAVECONFIRM_E : "Do you want to save?",
  PRCS_SAVECOMPLT : "저장 처리 완료 되었습니다.",
  PRCS_SAVECOMPLT_E : "Save completed.",
  PRCS_SUBMIT     : "제출 처리 완료 되었습니다.",
  PRCS_SUBMIT_E : "Submit completed.",
  PRCS_REJECT     : "반려 처리 완료 되었습니다.",
  PRCS_REJECT_E : "Reject completed.",
  PRCS_DELETECONFIRM : "삭제 하시겠습니까?",
  PRCS_DELETECONFIRM_E : "Do you want to delete?",
  PRCS_DELETECOMPLT : "삭제 처리 완료 되었습니다.",
  PRCS_DELETECOMPLT_E : "Delete completed.",
  PRCS_FAILSAVE   : "저장에 실패 하였습니다.",
  PRCS_FAILSAVE_E : "Failed to save.",

  //SEARCH
  SRCH_COMPLT     : "조회가 완료되었습니다.",
  SRCH_COMPLT_E : "Search completed.",
  SRCH_NODATA     : "조회조건의 데이터가 존재하지 않습니다.",
  SRCH_NODATA_E : "No data found.",
  SRCH_FAILURE    : "조회가 실패하였습니다.",
  SRCH_FAILURE_E : "Search failed.",
  SRCH_VALID      : "조회조건을 확인해 주십시오.",
  SRCH_VALID_E : "Please check the search conditions.",

  //GRID
  GRID_DUPLICATED : "그리드에 중복된 데이터가 있습니다.\n다시 확인해주세요.",
  GRID_DUPLICATED_E : "There is a duplicate data in the grid.\nPlease check again.",
  GRID_NOSELECTED : "그리드에 선택된 데이터가 없습니다.\n다시 확인해주세요.",
  GRID_NOSELECTED_E : "There is no selected data in the grid.\nPlease check again.",
  GRID_EDITINGNOW : "그리드가 현재 편집중에 있습니다.\n완료 후 진행해주세요.",
  GRID_EDITINGNOW_E : "The grid is currently being edited.\nPlease complete it after completion.",
  GRID_NOSAVEDATA : "저장 할 데이터가 없습니다.\n확인 후 진행주세요.",
  GRID_NOSAVEDATA_E : "There is no data to save.\nPlease check and proceed.",

  //ATTACH
  ATCH_INITFILE : "파일을 다시 올리시겠습니까?\n현재 담은 파일은 초기화됩니다.",
  ATCH_INITFILE_E : "Do you want to re-upload the file?\nThe current file is initialized.",


  //유효검사
  VALID_NOFORMS : "양식의 항목수가 상이가 합니다. \n지정된 양식을 사용해주세요!",
  VALID_NOFORMS_E : "The number of form items is different. \nPlease use the specified form.",

  VAILD: {
    NUMBER : "숫자만 입력할 수 있습니다.",
    NUMBER_E : "Only numbers can be entered.",
    NO_ENG : "영문은 입력할 수 없습니다.",
    NO_ENG_E : "English is not allowed to be entered.",
    NO_KOR : "한글은 입력할 수 없습니다.",
    NO_KOR_E : "Korean is not allowed to be entered.",
  }
}

export default MSG;
